<div class="contents-area" (dragstart)="onDragstartBody($event)">
  <div class="element-column">
    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title">権限</label>
        <div class="list-input-content" style="width: 52rem;">
          <app-text-input id="tbx_authority" #tbx_authority [subid]="'tbx_authority'"
            [tabindex]="0" [displayCountField]="false"  [forcedEnabledMode]="'true'"
            [(ngModel)]="kymw9003Model.authoritySetName" [maxChars]="50" [restrict]="'[ -￮]'">
          </app-text-input>
        </div>
      </div>

      <div class="column-list" style="width: 230px;">
        <label class="list-input-title">管理者権限</label>
        <div class="list-input-content">
          <select [(ngModel)]="kymw9003Model.adminDiv">
            <option value="99">すべて</option>
            <option value="1">管理者権限あり</option>
            <option value="0">管理者権限なし</option>
          </select>
        </div>
      </div>

      <div class="column-list" style="width: 220px;">
        <label class="list-input-title">有効/無効</label>
        <div class="list-input-content">
          <select [(ngModel)]="kymw9003Model.authorityStatus">
            <option value="99">すべて</option>
            <option value="0">有効のみ</option>
            <option value="1">無効のみ</option>
          </select>
        </div>
      </div>
    </div>
		<button class="btn-secondary" (click)="eventDisplayAuthoritySetList_CLICKHandler()">表示</button>
	</div>

	<wj-flex-grid [style.width.px]="1623" [style.height.px]="751" id="dg_AuthoritySetList" #dg_AuthoritySetList
		[itemsSource]="kymw9003Model.authoritySetList" [frozenColumns]="1" [headersVisibility]="'Column'"
		draggableColumns="false" horizontalScrollPolicy="on" liveScrolling="false" selectable="true" [isReadOnly]="true"
		[allowDragging]="'None'" forcedEnabledMode="true" [tabindex]="0" [selectionMode]="'Row'">
		<wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'ID'" [binding]="'authoritySetId'">
		</wj-flex-grid-column>
		<wj-flex-grid-column [minWidth]="5" [width]="300" [header]="'権限'" [binding]="'authoritySetName'">
		</wj-flex-grid-column>
		<wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'管理者権限'" [binding]="'adminDiv'" [align]="'center'">
		</wj-flex-grid-column>
		<wj-flex-grid-column [minWidth]="5" [width]="1005" [header]="'説明'" [binding]="'authoritySetExplanation'">
		</wj-flex-grid-column>
		<wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'有効/無効'" [binding]="'authorityStatus'">
		</wj-flex-grid-column>
	</wj-flex-grid>
</div>

<footer class="footer-buttons">
  <button id="btn_Regist" class="btn-primary" (click)="eventRegistBtn_CLICKHandler()"
    forcedEnabledMode="true" [tabindex]="0" [disabled]="disabledRegist">新規登録</button>
</footer>
